import { Component, OnInit } from '@angular/core';
import { Edit, LucideAngularModule, Plus } from 'lucide-angular';
import { VenueService } from '../shared/venue.service';
import { VenueModel } from '../shared/venue.model';
import { RouteParams } from '@app/shared/abstract/route-params';
import { RouterLink } from '@angular/router';
import { DataTableComponent } from '@app/partials/datatable/data-table/data-table.component';
import { PagedEntities } from '@app/shared/abstract/paged-entities';
import { Column } from '@app/partials/datatable/data-table/column';
import { RowAction } from '@app/partials/datatable/data-table/row-action';
import { AuthService } from '@app/auth/auth.service';
import { UserModel } from '@app/users/shared/user.model';

@Component({
  selector: 'app-venues',
  imports: [LucideAngularModule, RouterLink, DataTableComponent],
  templateUrl: './venues-index.component.html',
  styleUrl: './venues-index.component.css',
})
export class VenuesIndexComponent implements OnInit {
  constructor(private service: VenueService, private authService: AuthService) {}

  protected readonly PlusIcon = Plus;
  protected readonly EditIcon = Edit;

  protected venuesPage?: PagedEntities<VenueModel>;
  protected currentUser: UserModel | null = null;
  protected isAdmin = false;
  protected isManager = false;

  routeParams = new RouteParams({
    pageNum: 1,
    pageSize: 100,
  });

  tableColumns: Column<VenueModel>[] = [
    { field: 'logo_1_sm', header: 'Picture', type: 'image' },
    { field: 'name', header: 'Name' },
    { field: 'address', header: 'Address' },
    { field: 'phone', header: 'Phone' },
    { field: 'website', header: 'Website' },
  ];

  rowActions: RowAction<VenueModel>[] = [];

  loadData() {
    this.service.getPage(this.routeParams).subscribe((res) => {
      this.venuesPage = res;
    });
  }

  ngOnInit(): void {
    this.authService.getUser().subscribe({
      next: (user) => {
        this.currentUser = user;
        this.isAdmin = user?.roles?.includes('admin') ?? false;
        this.isManager = user?.roles?.includes('manager') ?? false;
        this.configureRowActions();
        this.loadData();
      },
      error: () => {
        this.isAdmin = false;
        this.isManager = false;
        this.configureRowActions();
        this.loadData();
      },
    });
  }

  handleRoute(params: RouteParams) {
    this.routeParams.sort = params.sort;
    this.routeParams.pageNum = params.pageNum;
    this.routeParams.pageSize = params.pageSize;
    this.loadData();
  }

  private configureRowActions(): void {
    if (this.isAdmin) {
      this.rowActions = [
        {
          icon: this.EditIcon,
          routerLink: (item: VenueModel) => ['/venues', item.id, 'edit'],
        },
      ];
    } else if (this.isManager) {
      this.rowActions = [
        {
          icon: this.EditIcon,
          routerLink: (item: VenueModel) => ['/venues', item.id, 'edit'],
          title: () => 'Edit assigned venue',
        },
      ];
    } else {
      this.rowActions = [];
    }
  }
}
